import React from 'react';

const SocialNavItem = (props) => {
    return (
        <a target="_blank" href={props.to}><span className={"icon icon-" + props.icon}></span></a>
    );
};

export default SocialNavItem;
